'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _sfpReactModal = _interopRequireDefault(require("sfp-react-modal"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _translate = _interopRequireDefault(require("../translate"));

var _loader = _interopRequireDefault(require("../loader"));

var _filterSelect = _interopRequireDefault(require("./lib/filter-select"));

var _filterMenu = _interopRequireDefault(require("./lib/filter-menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var HofsearchFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(HofsearchFilter, _React$Component);

  function HofsearchFilter(props) {
    var _this;

    _classCallCheck(this, HofsearchFilter);

    _this = _possibleConstructorReturn(this, (HofsearchFilter.__proto__ || Object.getPrototypeOf(HofsearchFilter)).call(this, props));
    _this.state = {
      loading: false,
      modalOpen: false,
      visibleFilter: '',
      canton: [],
      brunchCantons: [],
      project: [],
      productionType: [],
      lgwProduct: [],
      soldout: [],
      membership: [],
      productionLabel: [],
      lgwDeliveryType: [],
      rubric: [],
      product: [],
      vacation: []
    };
    _this.loadData = _this.loadData.bind(_assertThisInitialized(_this));
    _this.isReadyToSearch = _this.isReadyToSearch.bind(_assertThisInitialized(_this));
    _this.onResetAll = _this.onResetAll.bind(_assertThisInitialized(_this));
    _this.onShowResultsClick = _this.onShowResultsClick.bind(_assertThisInitialized(_this));
    _this.onCloseFilterSelect = _this.onCloseFilterSelect.bind(_assertThisInitialized(_this));
    _this.onMenuClick = _this.onMenuClick.bind(_assertThisInitialized(_this));
    _this.updateFilter = _this.updateFilter.bind(_assertThisInitialized(_this));
    _this.resetFilter = _this.resetFilter.bind(_assertThisInitialized(_this));
    _this.resetVisibleFilter = _this.resetVisibleFilter.bind(_assertThisInitialized(_this));
    _this.setFilters = _this.setFilters.bind(_assertThisInitialized(_this));
    _this.filterConfig = _this.filterConfig.bind(_assertThisInitialized(_this));
    _this.filterConfigAll = _this.filterConfigAll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HofsearchFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadData();
      this.initFilter(this.props.activeFilters);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.lng !== this.props.lng) {
        this.loadData();
      } // update filter


      var activeFilters = this.props.activeFilters;
      var currentState = this.state;
      var updatedState = {};

      for (var key in activeFilters) {
        if (Object.hasOwn(currentState, key) && JSON.stringify(currentState[key]) !== JSON.stringify(activeFilters[key])) {
          updatedState[key] = activeFilters[key];
        }
      }

      if (Object.keys(updatedState).length > 0) {
        this.initFilter(this.props.activeFilters);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'farmsearch-filter'
      }, /*#__PURE__*/_react.default.createElement(_sfpReactModal.default, {
        closeHandler: this.props.closeModal,
        backgroundClickClose: !this.state.loading,
        escClose: !this.state.loading,
        isOpen: this.props.modalOpen,
        id: 'select-filter',
        changePlease: this.props,
        changePleaseTwo: this.state
      }, this.state.loading && /*#__PURE__*/_react.default.createElement(_loader.default, null), !this.state.loading && this.renderModalContent()));
    }
  }, {
    key: "renderModalContent",
    value: function renderModalContent() {
      var _this2 = this;

      var t = this.props.t;
      var filter = this.filterConfig(); //project filter items without lgw

      var projectItemsNoLgw = this.props.project;

      if (projectItemsNoLgw && projectItemsNoLgw.length) {
        projectItemsNoLgw = projectItemsNoLgw.filter(function (item) {
          return item.filterKey !== 'lgw';
        });
      }

      var isLgwProjectSet = false;

      if (this.props.iframe.query.project === 'lgw') {
        isLgwProjectSet = true;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-open"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-container'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x align-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12"
      }, /*#__PURE__*/_react.default.createElement(_filterMenu.default, {
        t: t,
        visible: this.state.visibleFilter === '',
        closeModal: this.props.closeModal,
        onResetAll: this.onResetAll,
        onShowResultsClick: this.onShowResultsClick,
        filter: filter,
        isReadyToSearch: this.isReadyToSearch,
        onMenuClick: this.onMenuClick,
        filters: this.state,
        isLgwProjectSet: isLgwProjectSet,
        numbersOfResults: this.props.numbersOfResults
      }), filter.map(function (filter) {
        // products are rendered in filter-rubric component
        if (filter.key === 'product') {
          return '';
        }

        return /*#__PURE__*/_react.default.createElement(_filterSelect.default, {
          t: t,
          key: filter.key,
          rubric: _this2.props.rubric,
          products: _this2.props.products,
          product: _this2.props.product,
          visible: _this2.state.visibleFilter === filter.key,
          items: _this2.props[filter.key],
          onCloseFilterClick: function onCloseFilterClick() {
            return _this2.resetVisibleFilter();
          },
          onResetFilterClick: function onResetFilterClick() {
            return _this2.resetFilter(filter.key);
          },
          onItemClick: function onItemClick(item) {
            return _this2.updateFilter(item, filter.key);
          },
          selectedItems: _this2.state[filter.key],
          selectedFilters: _this2.state,
          onShowResultsClick: _this2.onShowResultsClick,
          closeModal: _this2.props.closeModal,
          isLgwProjectSet: isLgwProjectSet,
          offersAvailability: _this2.props.offersAvailability,
          numbersOfResults: _this2.props.numbersOfResults
        });
      })))));
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this3 = this;

      function asyncEach(items, fn, i) {
        if (items.length <= 0) return;
        if (i >= items.length) return;
        if (!i) i = 0;
        fn(items[i]);
        setTimeout(function () {
          asyncEach(items, fn, ++i);
        }, 0);
      }

      asyncEach(this.filterConfigAll(), function (filterConfig) {
        if (!filterConfig.loadAction) {
          return;
        }

        _this3.props.dispatch(filterConfig.loadAction(_this3.props.i18n.language, _this3.props.iframe.query)).catch(console.error);

        if (filterConfig.loadForeign) {
          var loading = _this3.props.i18n.options.locales.filter(function (locale) {
            return locale !== _this3.props.i18n.language;
          });

          asyncEach(loading, function (language) {
            _this3.props.dispatch(filterConfig.loadAction(language, _this3.props.iframe.query, true)).catch(console.error);
          });
        }
      });
    }
  }, {
    key: "initFilter",
    value: function initFilter(activeFilter) {
      this.setState(function (prev) {
        return Object.assign(prev, activeFilter);
      });
    }
  }, {
    key: "isReadyToSearch",
    value: function isReadyToSearch() {
      var _this4 = this;

      var filter = this.filterConfig();
      return filter.reduce(function (ready, filter) {
        return _this4.state[filter.key].length > 0 || ready;
      }, false);
    }
  }, {
    key: "onResetAll",
    value: function onResetAll() {
      var filter = this.filterConfig();
      this.setState(filter.reduce(function (filters, filter) {
        filters[filter.key] = [];
        return filters;
      }, {}), this.setFilters);
    }
  }, {
    key: "onShowResultsClick",
    value: function onShowResultsClick() {
      if (this.isReadyToSearch()) {
        this.resetVisibleFilter();
        this.props.closeModal();
        this.props.onCloseFilterMenu();
      }
    }
  }, {
    key: "onCloseFilterSelect",
    value: function onCloseFilterSelect() {
      this.setState({
        filterSelectVisible: false
      });
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(item, filter) {
      this.setState(function (prev) {
        var index = prev[filter].map(function (element) {
          return element.value;
        }).indexOf(item.value);

        if (index >= 0) {
          prev[filter].splice(index, 1);
        } else {
          prev[filter].push(item);
        }

        return prev;
      }, this.setFilters);
    }
  }, {
    key: "resetFilter",
    value: function resetFilter(filter) {
      this.setState(function (prev) {
        prev[filter] = [];
        return prev;
      }, this.setFilters);
    }
  }, {
    key: "onMenuClick",
    value: function onMenuClick(filter) {
      this.setState(function (prev) {
        prev.visibleFilter = filter;
        return prev;
      });
    }
  }, {
    key: "resetVisibleFilter",
    value: function resetVisibleFilter() {
      this.setState(function (prev) {
        prev.visibleFilter = '';
        return prev;
      });
    }
  }, {
    key: "setFilters",
    value: function setFilters() {
      var _this5 = this;

      var filters = this.filterConfig();
      this.props.setFilters(filters.reduce(function (filters, filter) {
        filters[filter.key] = _this5.state[filter.key];
        return filters;
      }, {}));
    }
  }, {
    key: "filterConfigAll",
    value: function filterConfigAll() {
      var _this$props$iframe$di = this.props.iframe.disabledFilter,
          disabledFilter = _this$props$iframe$di === void 0 ? [] : _this$props$iframe$di;
      var config = this.props.getFilterConfig();
      return config.filter(function (filter) {
        return disabledFilter.indexOf(filter.key) === -1;
      });
    }
  }, {
    key: "filterConfig",
    value: function filterConfig() {
      var _this6 = this;

      var config = this.filterConfigAll();
      return config.filter(function (config) {
        if (!_this6.props[config.key]) return false;

        if (!_this6.props.iframe.isIframe || _this6.props.iframe.query.project !== 'lgw') {
          if (config.key === 'lgwProduct' || config.key === 'lgwDeliveryType') {
            return false;
          }
        }

        if (!_this6.props.iframe.query.project === 'lgw' && config.key === 'lgwProduct' || !_this6.props.iframe.query.project === 'lgw' && config.key === 'lgwDeliveryType') {
          return false;
        }

        return _this6.props[config.key].length > 0;
      });
    }
  }]);

  return HofsearchFilter;
}(_react.default.Component);

HofsearchFilter.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    options: _propTypes.default.object
  }),
  searchData: _propTypes.default.shape({
    search: _propTypes.default.string
  }),
  setFilters: _propTypes.default.func,
  locations: _propTypes.default.array,
  product: _propTypes.default.array,
  rubric: _propTypes.default.array,
  products: _propTypes.default.array,
  dispatch: _propTypes.default.func.isRequired,
  lng: _propTypes.default.string,
  iframe: _propTypes.default.shape({
    disabledFilter: _propTypes.default.array,
    query: _propTypes.default.object,
    isIframe: _propTypes.default.bool
  }),
  activeFilters: _propTypes.default.any,
  getFilterConfig: _propTypes.default.func,
  onCloseFilterMenu: _propTypes.default.func,
  closeModal: _propTypes.default.func,
  openModal: _propTypes.default.func,
  modalOpen: _propTypes.default.bool,
  farms: _propTypes.default.array,
  project: _propTypes.default.array,
  offersAvailability: _propTypes.default.array,
  numbersOfResults: _propTypes.default.number
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, state.farm, {
    iframe: state.iframe
  }, {
    shared: state.shared
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(HofsearchFilter));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-filter/index.js
// module id = 874
// module chunks = 0